import React from 'react';

import { Button } from '@neptune/shared/venus-ui';

import { SalesLink } from 'components/sales-link/SalesLink';

type AdminActionProps = {
  caption: string;
  withContactSales?: boolean;
  onAction?: () => void;
};

export const AdminAction: React.FC<AdminActionProps> = ({
  caption,
  withContactSales,
  onAction,
}) => {
  return (
    <>
      {onAction && (
        <Button data-role="admin-action" onClick={onAction}>
          {caption}
        </Button>
      )}
      {withContactSales && <SalesLink>Contact sales</SalesLink>}
    </>
  );
};
